import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Theme } from '../../../utils/Theme'
import { withStyles } from '@material-ui/styles'
import AuthLayout from '../../layout/AuthLayout'
import * as QueryString from 'query-string'
import {  resendVerifyEmail } from '../../../redux/actions/userActions'
import Loading from '../../common/Loading'
import { isEmpty } from 'lodash'
import ResendVerifyEmail from './partials/ResendVerifyEmail'

const styles = Theme()

class VerifyEmailSent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      loading: true,
      errors: {},
      user: {},
    }
  }

  componentDidMount() {
    const { email } = QueryString.parse(this.props.location.search)

    this.setState({ loading: false, email })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let { errors } = prevState

    if (nextProps.auth.errors) {
      errors = nextProps.auth.errors
    }

    return { errors }
  }

  render() {
    const { loading, email } = this.state
    const { user, resendVerifyEmail, history, classes } = this.props

    console.log(this.props)

    return (
      <AuthLayout>
        {loading && <Loading />}
        <ResendVerifyEmail
          email={email}
          resendVerifyEmail={resendVerifyEmail}
          history={history}
          classes={classes}
        />
        {/*{isEmpty(user.user) && <Redirect to={'/login'} />}*/}
      </AuthLayout>
    )
  }
}

VerifyEmailSent.propTypes = {
  location: PropTypes.object.isRequired,
  auth: PropTypes.object,
  user: PropTypes.object,
  resendVerifyEmail: PropTypes.func.isRequired,
  history: PropTypes.object,
  classes: PropTypes.object,
}

const mapStateToProps = state => ({
  theme: state.theme,
  auth: state.auth,
  user: state.user,
})
export default connect(mapStateToProps, {  resendVerifyEmail })(
  withRouter(withStyles(styles)(VerifyEmailSent))
)
